<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                tableHeader
              }}</span>
            </h3>
            <div class="card-toolbar">
              <button
                class="btn btn-icon btn-active-light-primary cursor-pointer"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
              >
                <i class="fa-solid fa-filter"></i>
              </button>
              <a
                *ngIf="isUserList"
                [routerLink]="['/user/create']"
                class="create-new-button btn btn-sm fw-bold btn-primary"
                >{{ "createNewUser" | translate }}</a
              >
              <a
                *ngIf="isPatientList"
                [routerLink]="['/patient/a-p-s']"
                class="create-new-button btn btn-sm fw-bold btn-primary"
                >{{ "createNewPatient" | translate }}</a
              >
            </div>
          </div>

          <!-- List Loading -->
          <div
            *ngIf="tableLoading; else table"
            class="d-flex justify-content-center pb-4"
          >
            <div class="spinner-border text-danger" role="status">
              <span class="visually-hidden"
                >{{ "loading" | translate }}...</span
              >
            </div>
          </div>
          <!-- List -->
          <ng-template #table>
            <div class="card-body py-3">
              <div class="table-responsive">
                <!-- Filters -->
                <app-filters
                  [filters]="filters"
                  (filtersChange)="filterList($event)"
                >
                </app-filters>
                <!-- No data displayed -->
                <div
                  class="card-body py-3 text-center fs-5"
                  *ngIf="!data?.length; else tableBody"
                >
                  {{ "noData" | translate }}
                </div>
                <!-- Table -->
                <ng-template #tableBody>
                  <table
                    style="table-layout: fixed"
                    class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3"
                  >
                    <thead>
                      <tr class="fw-bold text-muted">
                        <th style="width: 25px">
                          <div
                            class="form-check form-check-sm form-check-custom form-check-solid"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value="1"
                              data-kt-check="true"
                              data-kt-check-target=".widget-13-check"
                            />
                          </div>
                        </th>
                        <th
                          *ngFor="let item of columns; let index = index"
                          class="text-gray-600 fw-bold cursor-pointer hover:bg-gray-100"
                          [ngClass]="columnWidths[index]"
                          (click)="
                            item.key !== 'AI' && item.key !== 'actions'
                              ? sortTable(item.key)
                              : null
                          "
                        >
                          <div class="d-flex align-items-center">
                            {{ item.translateKey | translate }}
                            <span *ngIf="sortColumn === item.key" class="ms-2">
                              <i
                                *ngIf="sortDirection === 'ascending'"
                                class="fas fa-arrow-up text-primary"
                              ></i>
                              <i
                                *ngIf="sortDirection === 'descending'"
                                class="fas fa-arrow-down text-primary"
                              ></i>
                            </span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let row of data"
                        (click)="handleRouting(row)"
                        [ngClass]="handleCursorPointer()"
                      >
                        <td>
                          <div
                            class="form-check form-check-sm form-check-custom form-check-solid"
                          >
                            <input
                              class="form-check-input widget-13-check"
                              type="checkbox"
                              value="1"
                            />
                          </div>
                        </td>
                        <td
                          *ngFor="let column of columns"
                          [ngClass]="{
                            'text-gray-900': true,
                            'text-hover-primary': column.key !== 'actions',
                            'fs-6': true
                          }"
                        >
                          <ng-container [ngSwitch]="column.key">
                            <!-- Name -->
                            <ng-container *ngSwitchCase="'nameAndSurname'">
                              {{ row.name }}
                              {{ row.surname || row.lastName || "-" }}
                            </ng-container>

                            <!-- Patient Name -->
                            <ng-container *ngSwitchCase="'patientName'">
                              {{ row.patientName }}
                              {{ row.patientLastName || "-" }}
                            </ng-container>

                            <!-- Created Date -->
                            <ng-container *ngSwitchCase="'createdDate'">
                              {{
                                (row[column.key] | date : "dd-MM-yyyy") || "-"
                              }}
                            </ng-container>

                            <!-- Created Date Time -->
                            <ng-container *ngSwitchCase="'createdDateTime'">
                              {{
                                (row[column.key] | date : "dd-MM-yyyy") || "-"
                              }}
                            </ng-container>

                            <!-- Incoming Date -->
                            <ng-container *ngSwitchCase="'incomingDate'">
                              {{
                                (row[column.key] | date : "dd-MM-yyyy") || "-"
                              }}
                            </ng-container>

                            <!-- Last Login Date -->
                            <ng-container *ngSwitchCase="'lastLoginDate'">
                              {{
                                (row[column.key] | date : "dd-MM-yyyy") || "-"
                              }}
                            </ng-container>

                            <!-- Patient Status -->
                            <ng-container *ngSwitchCase="'patientStatus'">
                              <span
                                class="badge"
                                [ngClass]="getStatusClass(row[column.key])"
                                >{{ getStatusName(row[column.key]) }}</span
                              >
                              <span
                                *ngIf="
                                  row?.chatStatuses?.includes(
                                    ChatStatus.MessageFromGp
                                  )
                                "
                                class="badge ms-2"
                                [ngClass]="
                                  getChatStatusClass(ChatStatus.MessageFromGp)
                                "
                                >{{
                                  getChatStatusText(ChatStatus.MessageFromGp)
                                }}</span
                              >
                            </ng-container>

                            <!-- User Status -->
                            <ng-container *ngSwitchCase="'userStatus'">
                              <span
                                class="badge ms-1"
                                [ngClass]="getUserStatusClass(row[column.key])"
                                >{{ getUserStatusText(row[column.key]) }}</span
                              >
                            </ng-container>

                            <!-- AI -->
                            <ng-container *ngSwitchCase="'AI'">
                              <span
                                class="badge"
                                [ngClass]="{
                                    'badge-light-secondary': row?.patientStatus === caseStatus.Open,
                                    'badge-light-warning': row?.patientStatus === caseStatus.AIAnalysing,
                                    'badge-light-success': row?.patientStatus > caseStatus.AIAnalysing,
                              }"
                                >{{ "AI" | translate }}</span
                              >
                            </ng-container>

                            <!-- Actions -->
                            <ng-container *ngSwitchCase="'actions'">
                              <div class="d-flex align-items-center">
                                <!-- Activate Button -->
                                <a
                                  *ngIf="
                                    (column.actionTypes.includes('activate') &&
                                      row.userStatus === userStatus.Blocked) ||
                                    row.userStatus === userStatus.DeActive
                                  "
                                  (click)="
                                    actionButtonClick('activate', row);
                                    row.userStatus = userStatus.Active
                                  "
                                  class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                                  title="{{ 'activate' | translate }}"
                                  ><i class="fa-regular fa-circle-check"></i
                                ></a>
                                <!-- Block Button -->
                                <a
                                  *ngIf="
                                    column.actionTypes.includes('block') &&
                                    row.userStatus === userStatus.Active
                                  "
                                  (click)="
                                    actionButtonClick('block', row);
                                    row.userStatus = userStatus.Blocked
                                  "
                                  class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                                  title="{{ 'block' | translate }}"
                                  ><i class="fa-solid fa-ban"></i
                                ></a>
                                <!-- Edit Button -->
                                <a
                                  *ngIf="column.actionTypes.includes('edit')"
                                  (click)="actionButtonClick('edit', row)"
                                  class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                                  title="{{ 'edit' | translate }}"
                                  ><i class="fa-regular fa-pen-to-square"></i
                                ></a>
                                <!-- Delete Button -->
                                <a
                                  *ngIf="column.actionTypes.includes('delete')"
                                  (click)="handleDelete(row, $event)"
                                  class="delete btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                                  title="{{ 'delete' | translate }}"
                                  ><i class="fa-regular fa-trash-can"></i
                                ></a>
                              </div>
                            </ng-container>

                            <!-- Default -->
                            <ng-container *ngSwitchDefault>
                              {{ row[column.key] || "-" }}
                            </ng-container>
                          </ng-container>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ng-template>
              </div>
            </div>
          </ng-template>
        </div>
        <!-- Pagination -->
        <app-pagination
          [type]="footerText"
          [currentPage]="currentPage"
          [totalPage]="totalPage"
          [pageSize]="pageSize"
          [pageSizes]="pageSizes"
          [totalItems]="totalCount"
          [items]="data"
          (pageChange)="pageChange($event)"
          (pageSizeChange)="pageSizeChange($event)"
        ></app-pagination>
      </div>
    </div>
  </div>
</div>

<!-- Delete Modal -->
<app-delete-modal
  [data]="data"
  [deleteModalId]="deleteModalId"
  [listName]="listName"
  (deleteEvent)="deleteEvent()"
></app-delete-modal>
